module.exports = __webpack_public_path__ + "img/logo_head.306ee10a.svg";